<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              
              <v-row> 
                <v-text-field v-model="editedItem.NAME" :label="$t('inputevent_col2')" outlined
                  v-if="itemList[0] != null"
                  ></v-text-field>
              </v-row>
              <v-row> 
                <v-textarea 
                  counter="250" v-model="editedItem.INPUTDESC"
                  :label="$t('inputevent_col3')" value="" outlined :rules="[ v => (v.length <= 250) || '입력문구는 250자 까지 입력이 가능합니다.' ]"></v-textarea>
              </v-row>
              <v-row> 
                <v-textarea 
                  counter="250" v-model="editedItem.INPUTCOMMENT"
                  :label="$t('inputevent_col13')" value="" outlined :rules="[ v => (v.length <= 250) || '설명문구는 250자 까지 입력이 가능합니다.' ]"></v-textarea>
              </v-row>
              <v-row> 
                <v-text-field v-model="editedItem.ENAME" :label="$t('inputevent_col10')" outlined
                  v-if="itemList[0] != null"
                  ></v-text-field>
              </v-row>
              <v-row> 
                <v-textarea 
                  counter="250" v-model="editedItem.EINPUTDESC"
                  :label="$t('inputevent_col11')" value="" outlined :rules="[ v => (v.length <= 250) || '입력문구는 250자 까지 입력이 가능합니다.' ]"></v-textarea>
              </v-row>
              <v-row> 
                <v-textarea 
                  counter="250" v-model="editedItem.EINPUTCOMMENT"
                  :label="$t('inputevent_col12')" value="" outlined :rules="[ v => (v.length <= 250) || '설명문구는 250자 까지 입력이 가능합니다.' ]"></v-textarea>
              </v-row>

              <v-row class="mt-2">
                <v-col cols="6">
                <v-select outlined v-model="editedItem.USETYPE" :items="USELIST" hide-details
                :label="$t('inputevent_col4')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"
                  v-if="itemList[0] != null && itemList[0].INPUT_CODE != editedItem.INPUT_CODE"
                  />
                </v-col>
                <v-col cols="6">
                <v-select outlined v-model="editedItem.REQTYPE" :items="REQLIST" hide-details
                :label="$t('inputevent_col5')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" :disabled="editedItem.LANTYPE == 4"
                  v-if="itemList[0] != null && itemList[0].INPUT_CODE != editedItem.INPUT_CODE"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select outlined v-model="editedItem.SHOWTYPE" :items="USELIST" hide-details
                  :label="$t('inputevent_col14')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"
                    v-if="itemList[0] != null && itemList[0].INPUT_CODE != editedItem.INPUT_CODE"
                    />
                </v-col>
                <v-col cols="6">
                  <v-select outlined v-model="editedItem.LANTYPE" :items="LANLIST" hide-details :label="$t('inputevent_label2')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" @change="changetype"/>
                </v-col>
              </v-row>
              
              <template v-if="editedItem.LANTYPE == 4">
                <v-row dense> 
                  <v-col cols="6">
                    <v-text-field type="number" v-model="editedItem.WIDTH" hide-details :label="$t('inputevent_label3')" counter="4" outlined
                      />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field type="number" v-model="editedItem.HEIGHT" hide-details :label="$t('inputevent_label4')" counter="4" outlined
                      />
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="editedItem.LANTYPE < 4">
                <v-row> 
                  <v-col cols="6">
                    <v-text-field outlined
                      type="number"  v-model="editedItem.LIMITTEXT" :label="$t('inputevent_col7')" counter="3"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select outlined v-model="editedItem.MAXLINES" 
                    :items="USELIST" :label="$t('inputevent_col8')" item-text="name" item-value="value"/>
                  </v-col>
                </v-row>
              </template>


            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="end" dense>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
          <comdialog   :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">         
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.INPUT_CODE>
          <label class="cheader_normal" >{{$t("inputevent_col1")}}</label>
        </template>
        <template v-slot:header.NAME>
          <label class="cheader_normal" >{{$t("inputevent_col2")}}</label>
        </template>
        <template v-slot:header.INPUTDESC>
          <label class="cheader_normal" >{{$t("inputevent_col3")}}</label>
        </template>
        <template v-slot:header.ENAME>
          <label class="cheader_normal" >{{$t("inputevent_col10")}}</label>
        </template>
        <template v-slot:header.EINPUTDESC>
          <label class="cheader_normal" >{{$t("inputevent_col11")}}</label>
        </template>
        <template v-slot:header.USETYPE>
          <label class="cheader_normal" >{{$t("inputevent_col4")}}</label>
        </template>
        <template v-slot:header.REQTYPE>
          <label class="cheader_normal" >{{$t("inputevent_col5")}}</label>
        </template>
        <template v-slot:header.SHOWTYPE>
          <label class="cheader_normal" >{{$t("inputevent_col14")}}</label>
        </template>
        <template v-slot:header.LANTYPE>
          <label class="cheader_normal" >{{$t("inputevent_col6")}}</label>
        </template>
        <template v-slot:header.LIMITTEXT>
          <label class="cheader_normal" >{{$t("inputevent_col7")}}</label>
        </template>
        <template v-slot:header.MAXLINES>
          <label class="cheader_normal" >{{$t("inputevent_col8")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("inputevent_col9")}}</label>
        </template>

        <template v-slot:[`item.INPUT_CODE`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.INPUT_CODE}}</label>
        </template>
        <template v-slot:[`item.NAME`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.NAME}}</label>
        </template>
        <template v-slot:[`item.INPUTDESC`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.INPUTDESC}}</label>
        </template>

        <template v-slot:[`item.ENAME`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.ENAME}}</label>
        </template>
        <template v-slot:[`item.EINPUTDESC`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.EINPUTDESC}}</label>
        </template>

        <template v-slot:[`item.USETYPE`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.USETYPE}}</label>
        </template>
        <template v-slot:[`item.LIMITTEXT`]="{ item }">  
          <label :style="item.USETYPE==0 ? unusetext:usetext">{{item.LIMITTEXT}}</label>
        </template>
        <template v-slot:[`item.LANTYPE`]="{ item }">  
          <template v-if="item.LANTYPE == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label5')}}</label>
          </template>
          <template v-else-if="item.LANTYPE == 2">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label6')}}</label>
          </template>
          <template v-else-if="item.LANTYPE == 3">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label7')}}</label>
          </template>
          <template v-else-if="item.LANTYPE == 4">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label8')}}</label>
          </template>
          <template v-else>
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label13')}}</label>
          </template>
        </template>     
        <template v-slot:[`item.REQTYPE`]="{ item }">  
          <template v-if="item.REQTYPE == 0">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label9')}}</label>
          </template>
          <template v-else-if="item.REQTYPE == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label10')}}</label>
          </template>
        </template>     
        <template v-slot:[`item.SHOWTYPE`]="{ item }">  
          <template v-if="item.SHOWTYPE == 0">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label11')}}</label>
          </template>
          <template v-else-if="item.SHOWTYPE == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label12')}}</label>
          </template>
        </template>     
        <template v-slot:[`item.USETYPE`]="{ item }">  
          <template v-if="item.USETYPE == 0">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label11')}}</label>
          </template>
          <template v-else-if="item.USETYPE == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label12')}}</label>
          </template>
        </template>     

        <template v-slot:[`item.MAXLINES`]="{ item }">  
          <template v-if="item.MAXLINES == 0">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label11')}}</label>
          </template>
          <template v-else-if="item.MAXLINES == 1">
            <label :style="item.USETYPE==0 ? unusetext:usetext">{{$t('inputevent_label12')}}</label>
          </template>
        </template>     

        <template v-slot:[`item.actions`]="{ item }">  
            <v-icon :style="item.USETYPE==0 ? unusetext:usetext" class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
export default {
    data: () => ({
      useInfo:{},
      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          NAME:'',
          INPUTDESC:'',
          ENAME:'',
          EINPUTDESC:'',
          INPUTCOMMENT:'',
          EINPUTCOMMENT:'',
          LANTYPE:1,
          REQTYPE:1,
          USETYPE:1,
          SHOWTYPE:1,
          LIMITTEXT: 20,
          WIDTH:100,
          HEIGHT:100,
          ADMIN_IDX:null,
          COM_IDX:null,
          EVENT_IDX:null,
          INPUT_CODE:''
      },
      editedItem: {
      },
      
      unusetext:'color:#b0b0b0;text-align:center',
      usetext:'color:black;text-align:center',

      //테이블 정의
      headers: [
        {text: '순서',        value: 'INPUT_CODE', sortable: true, align:'center' },
        {text: '질문',        value: 'NAME', sortable: true, align:'left' },
        {text: '질문내용',    value: 'INPUTDESC', sortable: true, align:'left'},
        {text: '질문(영문)',   value: 'ENAME', sortable: true, align:'left' },
        {text: '질문내용(영문)', value: 'EINPUTDESC', sortable: true, align:'left'},
        {text: '질문사용여부', value: 'USETYPE', sortable: true, align:'center'},
        {text: '답변필수여부', value: 'REQTYPE', sortable: true, align:'center'},
        {text: '명단노출여부', value: 'SHOWTYPE', sortable: true, align:'center'},
        {text: '답변언어',     value: 'LANTYPE', sortable: true, align:'center'},
        {text: '글자제한',    value: 'LIMITTEXT', sortable: true, align:'center'},
        {text: '멀티라인',    value: 'MAXLINES', sortable: true, align:'center'},
        {text: '수정',      value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      //추가 변수들
      LANLIST: [
          {name:'한글', name2:"Korean",     value:1}
        , {name:'영문', name2:"English",    value:2}
        , {name:'한글영어', name2:"All",    value:3}
        , {name:'이미지', name2:"Image",    value:4}
        , {name:'파일', name2:"File",       value:5}
      ],
      REQLIST: [
          {name:'선택입력', name2:"Selected",  value:0}
        , {name:'필수입력', name2:"Required",  value:1}
      ],
      USELIST: [
          {name:'사용안함', name2:"Not Used",  value:0}
        , {name:'사용',  name2:"Used",    value:1}
      ],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
      

    },

    create(){

    },

    methods: {


      changetype(){
        if(this.editedItem.LANTYPE == 4){
          this.editedItem.REQTYPE = 1;
        }
      },

      // eslint-disable-next-line no-unused-vars
      visibilityChanged (isVisible, entry) {
        //console.log("visibilityChanged 1 " + isVisible + " / " + entry);
      },

      loadpage(){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;
          this.$http.post(this.$host+'/api/InputEventList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.useInfo = result.data.useData;
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('inputevent_msg1'));
          return;
        } 
        if(this.editedItem.INPUTDESC  == undefined || this.editedItem.INPUTDESC.length < 1){
          this.$alert(this.$t('inputevent_msg2'));
          return;
        } 
        if(this.editedItem.ENAME  == undefined || this.editedItem.ENAME.length < 1){
          this.$alert(this.$t('inputevent_msg7'));
          return;
        } 
        if(this.editedItem.EINPUTDESC  == undefined || this.editedItem.EINPUTDESC.length < 1){
          this.$alert(this.$t('inputevent_msg8'));
          return;
        } 

        if(this.editedItem.LANTYPE == 4){
          if(this.editedItem.WIDTH  == null || this.editedItem.WIDTH  == undefined){
            this.$alert(this.$t('inputevent_msg3'));
            return;
          } 
          if(this.editedItem.HEIGHT  == null || this.editedItem.HEIGHT  == undefined){
            this.$alert(this.$t('inputevent_msg4'));
            return;
          } 
          if(this.editedItem.WIDTH > 1200){
            this.$alert(this.$t('inputevent_msg5'));
            return;
          } 
          if(this.editedItem.HEIGHT > 1200){
            this.$alert(this.$t('inputevent_msg6'));
            return;
          } 
        }


        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/InputEventUpdate',{
                NAME: escape(this.editedItem.NAME)
              , INPUTDESC: escape(this.editedItem.INPUTDESC)
              , ENAME: escape(this.editedItem.ENAME)
              , EINPUTDESC: escape(this.editedItem.EINPUTDESC)
              , INPUTCOMMENT: this.editedItem.INPUTCOMMENT == null || this.editedItem.INPUTCOMMENT == undefined ? '' : escape(this.editedItem.INPUTCOMMENT)
              , EINPUTCOMMENT: this.editedItem.EINPUTCOMMENT == null || this.editedItem.EINPUTCOMMENT == undefined ? '' : escape(this.editedItem.EINPUTCOMMENT)
              , LANTYPE: this.editedItem.LANTYPE
              , REQTYPE: this.editedItem.REQTYPE
              , USETYPE: this.editedItem.USETYPE
              , SHOWTYPE: this.editedItem.SHOWTYPE
              , LIMITTEXT: this.editedItem.LIMITTEXT
              , WIDTH: this.editedItem.WIDTH == null || this.editedItem.WIDTH == undefined ? 0 : this.editedItem.WIDTH
              , HEIGHT:  this.editedItem.HEIGHT == null || this.editedItem.HEIGHT == undefined ? 0 : this.editedItem.HEIGHT
              , MAXLINES: this.editedItem.MAXLINES
              , INPUT_CODE: this.editedItem.INPUT_CODE
              , EVENT_IDX: this.editedItem.EVENT_IDX == null ? this.SEARCH_EVENT_IDX : this.editedItem.EVENT_IDX
              , COM_IDX: this.editedItem.COM_IDX == null ? this.SEARCH_COM_IDX : this.editedItem.COM_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX == null ? this.$session.get("ADMIN_IDX") : this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.loadpage();
      },
      

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },


      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>